export const watchData = {
	heading: {
		title: 'Frequently Asked Questions',
		subtitle: 'Who are in extremely love with eco friendly system.',
	},

	watchList: [
		{
			title: 'White Apple Watch',
			price: 399.99,
			imageSrc: '../../images/u1.jpg',
		},
		{
			title: 'Blue Apple Watch',
			price: 399.99,
			imageSrc: '../../images/u2.jpg',
		},
		{
			title: 'Brown Apple Watch',
			price: 399.99,
			imageSrc: '../../images/u3.jpg',
		},
		{
			title: 'Black Apple Watch',
			price: 399.99,
			imageSrc: '../../images/u4.jpg',
		},
	],
};
